import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export function FaqList({ items, prefix = "faq" }) {
  return (
    <Accordion type="single" collapsible className="divide-y divide-slate-200 border-y border-slate-200" data-testid={`${prefix}-list`}>
      {items.map((f, i) => (
        <AccordionItem key={f.q} value={`q${i}`} className="border-0">
          <AccordionTrigger className="py-5 text-left font-display text-lg font-bold text-ag-ink hover:no-underline [&[data-state=open]]:text-ag-blue" data-testid={`${prefix}-item-${i}`}>
            {f.q}
          </AccordionTrigger>
          <AccordionContent className="pb-6 text-base leading-relaxed text-slate-600">{f.a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
